import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M15.574 0H2.426A2.426 2.426 0 0 0 0 2.426v13.148A2.426 2.426 0 0 0 2.426 18H8.91l.01-6.432h-1.67a.394.394 0 0 1-.395-.393l-.008-2.073c0-.219.176-.396.394-.396h1.669V6.702c0-2.325 1.42-3.59 3.493-3.59h1.702c.218 0 .395.176.395.394v1.748a.394.394 0 0 1-.394.394h-1.045c-1.128 0-1.346.537-1.346 1.323v1.735h2.478c.236 0 .42.206.392.44l-.246 2.074a.394.394 0 0 1-.392.348h-2.221L11.716 18h3.858A2.426 2.426 0 0 0 18 15.575V2.425A2.426 2.426 0 0 0 15.574 0z"
        />
      </svg>
    )
  }
}

export default SvgFile
